import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import RegistrationPage from '../../containers/RegistrationPage';

import theme from '$/assets/theme';
import Layout from '$/components/elements/Layout';
import Providers from '$/components/elements/Layout/Providers';

export interface IRegistrationPageProps {}

const Registration = (props: IRegistrationPageProps) => {
  const { redirectRegistration } = useFlags();

  if (redirectRegistration) {
    window.location.href = 'https://www.deutsche-bildung.de/aktuelle-info/';
    return null;
  }

  return (
    <Providers>
      <Layout {...props} background={theme.colors.brandBlue10} showFooter>
        <RegistrationPage {...props} />
      </Layout>
    </Providers>
  );
};

export const getStaticProps = async (): Promise<IRegistrationPageProps> => {
  return {
    props: {},
  };
};

Registration.requireAuth = 'registration';

export default Registration;
